import types from './types';
export default {
  [types.SET_LOADING](state, isLoading) {
    state.loading = isLoading;
  },
  setIsNavOpen(state, payload) {
    state.isNavOpen = payload;
  },
  toggleNav(state) {
    state.isNavOpen = !state.isNavOpen;
  },
  setIsMobileDensity(state, value) {
    state.isMobileDensity = value;
  },
};
